// extracted by mini-css-extract-plugin
export default {"th":"ClientsView_th__HKWSU","sortControl":"ClientsView_sortControl__opFe2","sortIcon":"ClientsView_sortIcon__FKSbn"};